export function nextLocalMidnight(now: number): number {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).getTime();
}

/** One shared timer, not a polling timer per row; recompute after a sleeping tab returns. */
export function createLocalDayClock(environment = {
  now: () => Date.now(),
  setTimer: (fn: () => void, delay: number) => window.setTimeout(fn, delay),
  clearTimer: (timer: number) => window.clearTimeout(timer),
  onVisible: (fn: () => void) => {
    const handler = () => { if (document.visibilityState === 'visible') fn(); };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  },
}) {
  let snapshot = environment.now();
  let timer: number | undefined;
  let stopVisibility: (() => void) | undefined;
  const listeners = new Set<() => void>();
  const refresh = () => {
    if (timer !== undefined) environment.clearTimer(timer);
    snapshot = environment.now();
    timer = environment.setTimer(refresh, Math.max(1, nextLocalMidnight(snapshot) - snapshot));
    listeners.forEach(listener => listener());
  };
  return {
    getSnapshot: () => snapshot,
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      if (listeners.size === 1) {
        stopVisibility = environment.onVisible(refresh);
        refresh();
      }
      return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
          if (timer !== undefined) environment.clearTimer(timer);
          timer = undefined;
          stopVisibility?.();
          stopVisibility = undefined;
        }
      };
    },
  };
}
